import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Radio, Users, GraduationCap, AlertTriangle, ArrowRight } from "lucide-react";

// Widget compact "Qui est dans l'école maintenant ?" — dashboards Fondateur/Admin
export const PresenceWidget = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const load = () => api.get("/presence/live").then(({ data }) => setData(data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);

  if (!data) return null;
  const topClasses = (data.students.by_class || []).filter(c => c.present > 0).slice(0, 6);

  return (
    <div className="bg-[#1E3A8A] rounded-2xl p-5 text-white" data-testid="presence-widget">
      <div className="flex items-center justify-between flex-wrap gap-2 mb-4">
        <div className="flex items-center gap-2 font-heading font-bold">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-400" />
          </span>
          Qui est dans l&apos;école maintenant ?
        </div>
        <Link to="/dashboard/presence" className="text-xs font-semibold text-orange-300 hover:text-orange-200 flex items-center gap-1" data-testid="presence-widget-link">
          Vue détaillée <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="bg-white/10 rounded-xl p-3 text-center">
          <GraduationCap className="h-4 w-4 mx-auto mb-1 opacity-70" />
          <div className="text-2xl font-extrabold tabular-nums" data-testid="widget-students-present">{data.students.present_total}</div>
          <div className="text-[10px] uppercase opacity-70">Élèves présents</div>
        </div>
        <div className="bg-white/10 rounded-xl p-3 text-center">
          <Users className="h-4 w-4 mx-auto mb-1 opacity-70" />
          <div className="text-2xl font-extrabold tabular-nums" data-testid="widget-staff-present">{data.staff.present_total}</div>
          <div className="text-[10px] uppercase opacity-70">Personnel pointé</div>
        </div>
        <div className={`rounded-xl p-3 text-center ${data.students.alerts > 0 ? "bg-red-500/30" : "bg-white/10"}`}>
          <AlertTriangle className="h-4 w-4 mx-auto mb-1 opacity-70" />
          <div className="text-2xl font-extrabold tabular-nums" data-testid="widget-alerts">{data.students.alerts}</div>
          <div className="text-[10px] uppercase opacity-70">Alertes sorties</div>
        </div>
      </div>
      {topClasses.length > 0 ? (
        <div className="flex flex-wrap gap-2">
          {topClasses.map(c => (
            <span key={c.class_name} className="text-xs bg-white/10 rounded-full px-3 py-1 font-semibold">
              {c.class_name} · {c.present}{c.total ? `/${c.total}` : ""}
            </span>
          ))}
        </div>
      ) : (
        <div className="text-xs opacity-60 flex items-center gap-1"><Radio className="h-3 w-3" />Aucun élève scanné au portail pour l&apos;instant aujourd&apos;hui.</div>
      )}
    </div>
  );
};
